import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ListMarkerIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ListMarkerIcon = ({ className, ...props }: ListMarkerIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 16H10C8.89543 16 8 15.1046 8 14V8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>

);

export default ListMarkerIcon;
